if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          shareButton: this.querySelector('button'),
          shareSummary: this.querySelector('summary'),
          closeButton: this.querySelector('.share-button__close'),
          successMessage: this.querySelector('[id^="ShareMessage"]'),
          urlInput: this.querySelector('input'),
        };
        this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;
        this.detailsElement = this.querySelector('details');

        if (navigator.share) {
          this.detailsElement?.setAttribute('hidden', '');
          this.elements.shareButton?.classList.remove('hidden');
          this.elements.shareButton?.addEventListener('click', () => {
            navigator.share({ url: this.urlToShare, title: document.title });
          });
        } else {
          this.detailsElement?.addEventListener('toggle', this.toggleDetails.bind(this));
          this.detailsElement
            ?.querySelector('.share-button__copy')
            ?.addEventListener('click', this.copyToClipboard.bind(this));
          this.detailsElement?.querySelector('.share-button__close')?.addEventListener('click', this.close.bind(this));
        }
      }

      toggleDetails() {
        if (!this.detailsElement?.open) {
          this.elements.successMessage?.classList.add('hidden');
          if (this.elements.successMessage) this.elements.successMessage.textContent = '';
          this.elements.closeButton?.classList.add('hidden');
          this.elements.shareSummary?.focus();
        }
      }

      close() {
        this.detailsElement?.removeAttribute('open');
      }

      copyToClipboard() {
        if (!this.elements.urlInput) return;
        navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
          this.elements.successMessage?.classList.remove('hidden');
          if (this.elements.successMessage && window.accessibilityStrings?.shareSuccess) {
            this.elements.successMessage.textContent = window.accessibilityStrings.shareSuccess;
          }
          this.elements.closeButton?.classList.remove('hidden');
          this.elements.closeButton?.focus();
        });
      }

      updateUrl(url) {
        this.urlToShare = url;
        this.elements.urlInput.value = url;
      }
    }
  );
}